import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import React from 'react';

interface DraftLoadFilterProps<T> {
    label: string;
    items: T[];
    selectedIds: number[];
    itemLabelFn: (item: T) => string;
    optionStyleFn?: (optionId: number) => React.CSSProperties;
    onChange: (updatedId: number) => void;
}

export const DraftLoadFilter = <T,> (props: DraftLoadFilterProps<T & {id: number}>) => (
    <Accordion defaultExpanded sx={{ boxShadow: 'none' }} disableGutters>
        <AccordionSummary sx={{ padding: 0 }} expandIcon={<ExpandMoreIcon />}>
            <Typography variant='h6' color='text.secondary'>{props.label}</Typography>
        </AccordionSummary>
        <FormGroup sx={{ pb: '1rem', flexWrap: 'nowrap', maxHeight: '12rem', overflowY: 'scroll' }}>
            {props.items.map(x => (
                <FormControlLabel
                    key={x.id}
                    control={<Checkbox checked={props.selectedIds.includes(x.id)} onChange={() => props.onChange(x.id)} />}
                    label={props.itemLabelFn(x)}
                    slotProps={props.optionStyleFn ? {typography: {sx: props.optionStyleFn(x.id)}} : undefined}
                />
            ))}
        </FormGroup>
    </Accordion>
);
